import { ChevronRightIcon } from 'lucide-react'
import { motion } from 'motion/react'
import React from 'react'
import Markdown from 'react-markdown'
import BlurFade from '#app/components/magicui/blur-fade.tsx'
import { DATA } from '#app/data/portfolio.tsx'
import { cn } from '#app/utils/misc.tsx'

const BLUR_FADE_DELAY = 0.04

const proseClass =
	'prose text-muted-foreground dark:prose-invert max-w-full font-sans text-sm text-pretty'

const About = () => {
	const [isExpanded, setIsExpanded] = React.useState(false)

	return (
		<section id="about" className="container">
			<BlurFade delay={BLUR_FADE_DELAY * 3}>
				<h2 className="text-xl font-bold">About</h2>
			</BlurFade>
			<BlurFade delay={BLUR_FADE_DELAY * 4}>
				<div className={proseClass}>
					<Markdown>{DATA.summaryLead}</Markdown>
				</div>

				{DATA.summaryMore.length > 0 && (
					<>
						<motion.div
							initial={false}
							animate={{
								opacity: isExpanded ? 1 : 0,
								height: isExpanded ? 'auto' : 0,
							}}
							transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
							className="overflow-hidden"
						>
							<div className={cn(proseClass, 'pt-4')}>
								{DATA.summaryMore.map((paragraph, index) => (
									<Markdown key={index}>{paragraph}</Markdown>
								))}
							</div>
						</motion.div>

						<button
							type="button"
							onClick={() => setIsExpanded((v) => !v)}
							aria-expanded={isExpanded}
							className="text-muted-foreground hover:text-foreground focus-visible:text-foreground mt-1 inline-flex items-center gap-x-0.5 rounded-sm text-sm font-medium transition-colors"
						>
							{isExpanded ? 'See less' : 'See more'}
							<ChevronRightIcon
								className={cn(
									'size-4 transition-transform duration-300 ease-out',
									isExpanded ? 'rotate-90' : 'rotate-0',
								)}
							/>
						</button>
					</>
				)}

				<div className={cn(proseClass, 'mt-2')}>
					<Markdown>{DATA.summaryFooter}</Markdown>
				</div>
			</BlurFade>
		</section>
	)
}

export default About
